(() => {
  const productPage = document.querySelector('product-info');

  const addBreadcrumbs = (container, current) => {
    if (!container || container.querySelector('.cb-breadcrumbs')) return;
    const nav = document.createElement('nav');
    nav.className = `cb-breadcrumbs${container.classList.contains('page-width') ? '' : ' page-width'}`;
    nav.setAttribute('aria-label', 'Breadcrumb');
    nav.innerHTML = `
      <a href="/">Home</a><span aria-hidden="true">/</span>
      <a href="/collections">Catalog</a><span aria-hidden="true">/</span>
      <span class="cb-breadcrumbs__current" aria-current="page"></span>`;
    nav.querySelector('.cb-breadcrumbs__current').textContent = current;
    container.prepend(nav);
  };

  document.querySelectorAll('.collection-hero').forEach((hero) => {
    const title = hero.querySelector('h1')?.innerText.trim();
    if (title) addBreadcrumbs(hero, title);
  });

  if (productPage) {
    const title = productPage.querySelector('h1')?.innerText.trim() || document.title.split('–')[0].trim();
    const page = productPage.querySelector('.page-width');
    addBreadcrumbs(page, title);

    const description = productPage.querySelector('.product__description');
    if (description) description.id ||= `ProductDescription-${productPage.dataset.section || 'main'}`;

    const descriptionText = description?.innerText || '';
    const media = productPage.querySelector('.product__media-wrapper');
    if (media && !media.querySelector('.cb-styled-view-note') && /AI[- ]generated/i.test(descriptionText)) {
      const note = document.createElement('p');
      note.className = 'cb-styled-view-note';
      note.textContent = 'Some room-setting images are styled visualizations. Product photographs and detail views show the actual piece.';
      media.append(note);
    }

    const reviewProof = productPage.querySelector('.shop-review-proof');
    const nativeProductSubmit = productPage.querySelector('button[name="add"]');
    const isSoldPiece = nativeProductSubmit?.disabled && /sold out/i.test(nativeProductSubmit.innerText || '');
    if (isSoldPiece && !productPage.querySelector('.cb-sold-piece')) {
      productPage.classList.add('cb-product--sold');
      const purchaseForm = nativeProductSubmit.closest('product-form') || nativeProductSubmit.closest('.product-form');
      [
        purchaseForm,
        productPage.querySelector('.product-form__quantity'),
        productPage.querySelector('form.installment')?.parentElement,
        productPage.querySelector('pickup-availability'),
        productPage.querySelector('.cb-product-assistance'),
      ].forEach((element) => {
        if (element) {
          element.hidden = true;
          element.style.setProperty('display', 'none', 'important');
        }
      });

      const soldNotice = document.createElement('aside');
      soldNotice.className = 'cb-sold-piece';
      soldNotice.setAttribute('aria-labelledby', 'SoldPieceTitle');
      soldNotice.innerHTML = `
        <p class="cb-sold-piece__eyebrow">Past selection</p>
        <h2 id="SoldPieceTitle">This piece has sold.</h2>
        <p>Explore available inventory or contact Casa Bauhaus to discuss what you are sourcing.</p>
        <div class="cb-sold-piece__actions">
          <a class="button button--primary" href="/collections/all?filter.v.availability=1">View available pieces</a>
          <a class="button button--secondary" href="/pages/contact">Request sourcing help</a>
        </div>`;
      (purchaseForm || reviewProof || productPage.querySelector('.product__info-container'))?.before(soldNotice);
    }
    if (reviewProof && !productPage.querySelector('.cb-product-assistance')) {
      const productUrl = `${location.origin}${location.pathname}`;
      const assistance = document.createElement('div');
      assistance.className = 'cb-product-assistance';
      assistance.setAttribute('aria-label', 'Product assistance');
      assistance.innerHTML = `
        <a class="button button--secondary" href="mailto:hello@casabauhaus.com">Ask about this piece</a>
        <a class="button button--secondary" href="mailto:hello@casabauhaus.com">Request photos or video</a>`;
      const links = assistance.querySelectorAll('a');
      links[0].href = `mailto:hello@casabauhaus.com?subject=${encodeURIComponent(`Question about ${title}`)}&body=${encodeURIComponent(productUrl)}`;
      links[1].href = `mailto:hello@casabauhaus.com?subject=${encodeURIComponent(`Photo or video request for ${title}`)}&body=${encodeURIComponent(productUrl)}`;
      reviewProof.before(assistance);
    }

    if (reviewProof && !productPage.querySelector('.cb-product-facts')) {
      const dimensionsMarker = /(?:Each (?:chair|piece|item) measures?|Dimensions?)\s*:\s*/i.exec(descriptionText);
      const dimensionsTail = dimensionsMarker
        ? descriptionText.slice(dimensionsMarker.index + dimensionsMarker[0].length, dimensionsMarker.index + dimensionsMarker[0].length + 260)
        : '';
      const dimensions = dimensionsTail
        .split(/(?:\n\s*)?(?:Sold as|Condition\s*:|Shipping\s*:|FREE Shipping|■|🚚)/i)[0]
        .replace(/\s*\n\s*/g, ' · ')
        .trim();
      const facts = document.createElement('aside');
      facts.className = 'cb-product-facts';
      facts.setAttribute('aria-labelledby', 'ProductFacts-live');
      facts.innerHTML = `
        <h2 class="cb-product-facts__title" id="ProductFacts-live">Details at a glance</h2>
        <dl></dl>`;
      const rows = [];
      if (dimensions) rows.push(['Dimensions', dimensions]);
      rows.push(
        ['Condition', `<a class="underlined-link" href="#${description?.id || ''}">See condition notes and photographs</a>`],
        ['Delivery', 'Complimentary white-glove shipping · 2-30 business days']
      );
      facts.querySelector('dl').innerHTML = rows.map(([key, value]) => `<dt>${key}</dt><dd>${value}</dd>`).join('');
      reviewProof.after(facts);
    }

    const syncDimensions = () => {
      const facts = productPage.querySelector('.cb-product-facts dl');
      if (!facts || [...facts.querySelectorAll('dt')].some((item) => item.textContent === 'Dimensions')) return;
      const text = productPage.querySelector('.product__description')?.innerText || '';
      const marker = /(?:Each (?:chair|piece|item) measures?|Dimensions?)\s*:\s*/i.exec(text);
      if (!marker) return;
      const value = text
        .slice(marker.index + marker[0].length, marker.index + marker[0].length + 260)
        .split(/(?:\n\s*)?(?:Sold as|Condition\s*:|Shipping\s*:|FREE Shipping|■|🚚)/i)[0]
        .replace(/\s*\n\s*/g, ' · ')
        .trim();
      if (!value) return;
      facts.insertAdjacentHTML('afterbegin', `<dt>Dimensions</dt><dd></dd>`);
      facts.querySelector('dd').textContent = value;
    };
    syncDimensions();
    setTimeout(syncDimensions, 500);
  }

  const removeUnavailableRecommendations = (root = document) => {
    root.querySelectorAll('product-recommendations .grid__item').forEach((item) => {
      if (/sold out/i.test(item.innerText)) item.remove();
    });
  };

  removeUnavailableRecommendations();
  new MutationObserver(() => removeUnavailableRecommendations()).observe(document.body, {childList: true, subtree: true});
})();
